import { faCircleExclamation } from '@rq-ratings/pro-regular-svg-icons'
import React, { useState } from 'react'
import { Link, Outlet, useNavigate } from 'react-router'

import RqLogo from '../../../assets/img/logo.svg'
import { useAuth } from '../../../hooks/useAuth'
import { useLongPress } from '../../../hooks/useLongPress'
import { useOfficeContext } from '../../../hooks/useOfficeContext'
import { isDevelopment } from '../../../lib/helpers/envHelpers'
import { isOffice } from '../../../lib/helpers/officeHelpers'
import { ROUTES } from '../../../lib/routes'
import useCompleteOutlookOnboardingChecklistIfIsOfficeEffect from '../../../pages/gettingStarted/hooks/useCompleteOutlookOnboardingChecklistIfIsOfficeEffect'
import DiagnosticModal from '../../../pages/officeTaskPane/components/DiagnosticModal'
import InfoBox from '../../misc/InfoBox'
import PlainButton from '../../misc/PlainButton'
import LoadingWidget from '../../widgets/LoadingWidget'
import AccountDropdown from './components/AccountDropdown'

const OfficeLayout: React.FC = () => {
  const { isAuthenticated } = useAuth()
  const office = useOfficeContext()
  const isPageEnabled = isDevelopment() || isOffice()
  const navigate = useNavigate()
  const [showDiagnosticModal, setShowDiagnosticModal] = useState(false)

  useCompleteOutlookOnboardingChecklistIfIsOfficeEffect()

  const longPressProps = useLongPress({
    onLongPress: () => setShowDiagnosticModal(true),
    duration: 5000,
  })

  if (!isPageEnabled) {
    return (
      <InfoBox variant="yellowDark" className="mt-3" icon={faCircleExclamation}>
        This add-in is only available in the Outlook client.
      </InfoBox>
    )
  }

  if (!office.isInitialized) {
    return <LoadingWidget />
  }

  return (
    <main className="wrapper h-100 bg-white OfficeLayout">
      <div className="w-100">
        {isAuthenticated && (
          <header className="bg-white box-shadow-lg d-flex justify-content-between gap-3 py-3 mb-3 px-3 w-100 mb-4">
            <Link to={ROUTES.officeTaskPane}>
              <img
                src={RqLogo}
                alt="RQ Logo"
                className="position-relative"
                style={{ height: '40px', maxWidth: '45px', top: '-3px' }}
                {...longPressProps}
              />
            </Link>

            <div className="d-flex flex-column align-items-end">
              <AccountDropdown />

              <PlainButton
                className="text-sm"
                onClick={() =>
                  navigate(
                    ROUTES.signOut +
                      '?redirectUri=' +
                      encodeURIComponent(ROUTES.officeTaskPane),
                  )
                }
              >
                Sign out
              </PlainButton>
            </div>
          </header>
        )}

        <div className="mx-2">
          <Outlet />
        </div>
      </div>

      <DiagnosticModal
        show={showDiagnosticModal}
        onHide={() => setShowDiagnosticModal(false)}
      />
    </main>
  )
}

export default OfficeLayout
